// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"W","header":"X","title":"Y","description":"Z","subHeader":"aa","button":"ab"};